<script setup lang="ts">
import { isBellaSiciliaByDomain } from "~/utils/stores";

// FALLBACK
useHead({
  title: "Spuntini",
});

// https://scripts.nuxt.com/scripts/tracking/google-tag-manager
// Call GTM via useGtmTracking in other places.
const { GTM_ID_SPUNTINI, GTM_ID_BELLASICILIA } = useRuntimeConfig().public;

const { proxy } = useScriptGoogleTagManager({
  id: isBellaSiciliaByDomain() ? GTM_ID_BELLASICILIA : GTM_ID_SPUNTINI,
});

useScriptEventPage(({ title, path }) => {
  const { loggedIn, user } = useUserSession();

  if (loggedIn.value && user.value) {
    proxy.dataLayer.push({ customerId: `${user.value.customerId}` });
  }

  // triggered on route change after title is updated
  proxy.dataLayer.push({
    event: "pageview",
    title: title,
    path: path,
  });
});
</script>

<template>
  <UApp>
    <NuxtLoadingIndicator color="#C81414" />
    <NuxtRouteAnnouncer />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
